import React, { Component } from 'react';
import $ from "jquery";

import pdf1 from "./../PDF/Ley_27130.pdf";
import pdf2 from "./../PDF/Ley_26667.pdf";

import pdf3 from "./../PDF/Unicef-2019-Suicidio adolescente.pdf";
import pdf4 from "./../PDF/Lineamientos para la atención del intento de suicidio en adolescentes. Ministerio de Desarrollo Social y Salud de la Nación, 2018.pdf";
import pdf5 from "./../PDF/Lineamientos generales para la comprensión, detección y prevención. UBA, 2016.pdf";
import pdf6 from "./../PDF/Políticas de cuidado en la escuela. Aportes para trabajar la problemática del suicidio e intentos de suicidio. BsAs. 2017.pdf";
import pdf7 from "./../PDF/Prevención del suicidio. Un instrumento para policías, bomberos y otros socorristas de primera línea. Organización Mundial de la Salud, 2009.pdf";
import pdf8 from "./../PDF/Guía dirigida a profesionales sanitarios y facilitadores sociales. Comunidad de Madrid, España, 2014.pdf";
import pdf9 from "./../PDF/Guía de autoayuda. Comunidad de Madrid, España, 2014.pdf";
import pdf10 from "./../PDF/Guía para familiares. Comunidad de Madrid, España, 2014.pdf";
import pdf11 from "./../PDF/Recomendaciones sobre la detección, prevención e intervención de la conducta suicida. Servicio Andaluz de Salud, España, 2010.pdf";
import pdf12 from "./../PDF/Guía de Práctica Clínica de Prevención y Tratamiento de la Conducta Suicida. Ministerio de Sanidad y Política Social, España, 2012.pdf";

import imgDC from "./../images/imagenProfesionales.png";

import "./../styles/formTextItem.css";

const StyleLiPDFS = {marginBottom: "10px", borderBottom: "1px solid rgba(0,0,0,.2)"};

export default class PagProfesionales extends Component {
    componentDidMount(){
        $(".seccion h3").click(function(){
            if($(this).siblings(".secContenido").height() > 0){
                $(this).siblings(".secContenido").animate({"height": "0px"}, {
                    easing: "linear",
                    duration: "150"
                });
            }
            else{
                const elementHeight = $(this).siblings(".secContenido").css({"height": "auto"}).height();
                $(this).siblings(".secContenido").css({"height": "0"});
                $(this).siblings(".secContenido").animate({"height": elementHeight + "px"}, {
                    easing: "linear",
                    duration: "100",
                    complete: () => {
                        //setTimeout(()=>{$(this).siblings(".secContenido").css({"height": "auto"})}, 1000);
                        $(this).siblings(".secContenido").css({"height": "auto"})
                    }
                });
            }
            $(this).toggleClass("icon-plus");
            $(this).toggleClass("icon-minus");
        });
        $(".seccion h4").click(function(){
            if($(this).siblings(".secContenido").height() > 0){
                $(this).siblings(".secContenido").animate({"height": "0px"}, {
                    easing: "linear",
                    duration: "100",
                    complete: () => {
                        $(this).siblings(".secContenido").css({"marginTop": "0px"})
                    }
                });
            }
            else{
                const elementHeight = $(this).siblings(".secContenido").css({"height": "auto"}).height();
                $(this).siblings(".secContenido").css({"height": "0"});
                $(this).siblings(".secContenido").css({"marginTop": "15px"})
                $(this).siblings(".secContenido").animate({"height": elementHeight + "px"}, {
                    easing: "linear",
                    duration: "100",
                    complete: () => {
                        //setTimeout(()=>{$(this).siblings(".secContenido").css({"height": "auto"})}, 1000);
                        $(this).siblings(".secContenido").css({"height": "auto"})
                    }
                });
            }
            $(this).toggleClass("icon-plus");
            $(this).toggleClass("icon-minus");
        });

    }

    render() {
        return (
            <React.Fragment>
                <div className="card formTextItem">
                    <h1>Marco legal y normativo argentino</h1>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Ley Nacional de prevencion del suicidio N°27.130</b></h4>
                        <div class="secContenido">
                            <p>Descargar: <a href={pdf1}>Ley Nacional de prevencion del suicidio N°27.130</a></p>
                        </div>
                    </div>
                    <div class="seccion">
                        <h4 class="icon-plus"><b>Ley Nacional de salud mental N°26.667</b></h4>
                        <div class="secContenido">
                            <p>Descargar: <a href={pdf2}>Ley Nacional de salud mental N°26.667</a></p>
                        </div>
                    </div>
                </div>

                <div class="card formTextItem">
                        <h1>Delimitaciones conceptuales</h1>
                        <img src={imgDC} style={{width: "90%", margin: "10px auto"}} alt="Clasifación de los pensamientos y comportamientos autodestructivos"/>
                        <div className="seccion">
                            <h4 class="icon-plus"><b>Definiciones:</b></h4>
                            <div class="secContenido">
                                <ul>
                                <li><b>Suicidio:</b> acto deliberado que realiza una persona para poner fin a su vida.</li>
                                <li><b>Ideación suicida:</b> en sentido estricto, comprende la aparición de pensamientos y sentimientos cuyo contenido se relaciona con poner fin a la propia existencia.</li>
                                <li><b>Plan suicida:</b> formulación concreta y específica de un método para quitarse la vida y la posible preparación para llevarlo a cabo. La presencia de un plan suicida está altamente vinculada a una mayor probabilidad de cometer un intento de suicidio.</li>
                                <li><b>Intento de suicidio:</b> alude a la tentativa deliberada de autoeliminación o autolesión intencionada sin resultado de muerte.</li>
                                <li><b>Riesgo de suicidio:</b> propensión que exhibe una persona en un momento dado para desarrollar ideaciones suicidas y/o cometer un intento de suicidio.</li>
                                <li><b>Gesto suicida:</b> acto realizado con el fin de aparentar la intención de quitarse la vida para lograr atención y comunicación con el entorno. Es un claro pedido de ayuda que no hay que minimizar.</li>
                                <li><b>Pensamientos sobre autolesiones no suicidas:</b> pensamientos y sentimientos vinculados a provocarse daño físico, sin presencia de ideas sobre quitarse la propia vida.</li>
                                <li><b>NSSI Autolesiones no suicidas:</b> lesiones autoinfligidas en la superficie corporal como mecanismo regulatorio de un estado negativo emocional o cognitivo, sin intencionalidad suicida.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                
                <div className="card formTextItem">
                    <h1>Cómo evaluar el riesgo de suicidio</h1>
                    <p className="description">
                        Los hallazgos de la evaluación basada en la evidencia (EBA) en suicidología indican la importancia 
                        de comenzar siempre indagando la presencia de ideaciones suicidas, su frecuencia, contenido y 
                        duración, para luego abordar los temas y áreas más sensibles, como por ejemplo planeación, 
                        antecedentes de intento de suicidio de la persona y su familia, todo lo relativo a dicho plan o 
                        intento, comportamientos asociados a la capacidad adquirida para suicidarse (por ejemplo, presencia 
                        de autolesiones no suicidas - NSSI) (Nock, Wedig, Janis & Deliberto, 2008). Asimismo, es necesario 
                        indagar la presencia de factores protectores,  de riesgo y desencadenantes. Esta evaluación debe 
                        realizarse a través de una entrevista  individual, en un espacio de confianza y calidez. También 
                        se recomienda incluir otro tipo de técnicas de evaluación como cuestionarios psicológicos, para 
                        lograr un abordaje multimétodo.  <br/>
                        De forma complementaria, es necesario tener una entrevista con familiares y/o allegados para conocer 
                        su percepción de la situación y el estado general de la persona en crisis, así como realizar 
                        intervenciones concretas dirigidas a brindar información y orientar a la red de apoyo para el 
                        acompañamiento.
                    </p>
                    <p className="description">
                        Es muy importante mantener una determinada actitud cuando se entrevista a alguien con pensamientos suicidas:<br/>
                        <ul style={{padding: "10px 45px"}}>
                            <li>Ser comprensivo, cariñoso, empático, validar la experiencia y generar un clima de confianza.</li>
                            <li>Nunca juzgar la conducta, no estigmatizar, no atemorizarse, ni enojarse.</li>
                            <li>No minimizar ni maximizar el riesgo hasta finalizar la evaluación y determinar cuáles son las intervenciones más adecuadas.</li>
                            <li>Recordar que preguntarle a una persona con pensamientos y comportamientos suicidas sobre el tema, no aumenta el riesgo de suicidio, siempre que mantengamos una actitud de escucha y comprensión. </li>
                        </ul><br/>
                        Para profundizar esta información se recomienda revisar:<br/>
                        <ul style={{padding: "10px 45px"}}>
                            <li><a href={pdf5}>Lineamientos generales para la comprensión, detección y prevención (UBA, 2016).</a></li>
                            <li><a href={pdf12}>Guía de Práctica Clínica de Prevención y Tratamiento de la Conducta Suicida (Ministerio de Sanidad y Política Social, España, 2012).</a></li>
                        </ul>
                    </p>

                    <div class="seccion">
                        <h4 class="icon-plus">Dimensiones a evaluar</h4>
                        <div class="secContenido">

                        <div class="seccion">
                            <h4 class="icon-plus">Factores protectores</h4>
                            <div class="secContenido">
                                <ul>
                                    <li>Buena autoestima</li>
                                    <li>Percepción de contar con una red social de apoyo.</li>
                                    <li>Buena comunicación familiar.</li>
                                    <li>Sentimiento de pertenencia.</li>
                                    <li>Buena regulación emocional.</li>
                                    <li>Sensación de autocontrol.</li>
                                    <li>Capacidad para la resolución de problemas.</li>
                                    <li>Perspectiva optimista respecto del futuro.</li>
                                    <li>Flexibilidad.</li>
                                </ul>

                            </div>
                        </div>

                        <div class="seccion">
                            <h4 class="icon-plus">Factores de riesgo</h4>
                            <div class="secContenido">
                                <ul>
                                    <li>Baja autoestima</li>
                                    <li>Sentimientos de soledad y aislamiento, de estar atrapado.</li>
                                    <li>Percepción de ser una carga para los demás.</li>
                                    <li>Dificultades en la regulación emocional.</li>
                                    <li>Impulsividad.</li>
                                    <li>Dificultades en la resolución de problemas.</li>
                                    <li>Percepción de apoyo social.</li>
                                    <li>Perspectiva pesimista respecto del futuro.</li>
                                    <li>Autolesiones no suicidas.</li>
                                    <li>Presencia de cuadro psicopatológico (en especial: depresión mayor, trastorno bipolar, esquizofrenia, trastorno límite de personalidad).</li>
                                </ul>

                            </div>
                        </div>

                        <div class="seccion">
                            <h4 class="icon-plus">Factores precipitantes</h4>
                            <div class="secContenido">
                              <p>Presencia de algún o varios eventos vitales significativos que pueden desencadenar una crisis:</p>

                              <div class="seccion">
                                  <h4 class="icon-plus">Comunes a todas las edades</h4>
                                  <div class="secContenido">
                                      <ul>
                                          <li>Accidentes o diagnóstico, empeoramiento o crisis de enfermedades graves, incapacitantes o dolorosas. Propias o ajenas.</li>
                                          <li>Desastres naturales.</li>
                                          <li>Pérdida de seres queridos (incluidos animales de compañía).</li>
                                          <li>Existencia de entorno suicida: fácil acceso a medios letales, epidemias suicidas, suicidio de familiares o personas cercanas, acceso a información y relaciones inadecuadas en medios de información, comunicación y redes sociales etc..</li>
                                          <li>Experiencias y vivencias traumáticas: agresiones y malos tratos, acosos y humillaciones, abusos sexuales, etc.</li>
                                          <li>Aumento o consumo de sustancias tóxicas.</li>
                                          <li>Estado de embriaguez o intoxicación.</li>
                                          <li>Imputaciones o condenas judiciales.</li>
                                          <li>Disputas y conflictos con familiares o personas cercanas.</li>
                                          <li>Embarazo no deseado o aborto.</li>
                                          <li>Cambios vitales bruscos no deseados.</li>
                                          <li>Efectos secundarios suicidógenos de medicaciones.</li>
                                          <li>Alta por hospitalización psiquiátrica (primera semana).</li>
                                      </ul>

                                  </div>
                              </div>

                              <div class="seccion">
                                  <h4 class="icon-plus">Adolescentes y jóvenes</h4>
                                  <div class="secContenido">
                                      <ul>
                                          <li>Fracaso escolar. Problemas disciplinarios escolares. Presión escolar. Períodos de exámenes.</li>
                                          <li>Bullying, acoso, humillaciones, malos tratos.</li>
                                          <li>Abuso sexual. Violaciones.</li>
                                          <li>Discriminación y exclusión por la orientación sexual y/o su identidad de género.</li>
                                          <li>Separación o pérdida de amigos y compañeros. Cambios habituales de residencia y de entorno social.</li>
                                          <li>Desengaño amoroso.</li>
                                          <li>Muerte de un ser querido.</li>
                                          <li>Entorno suicida. Presión para cometer suicidio.</li>
                                          <li>Embarazo adolescente.</li>
                                          <li>Separación de los padres o graves conflictos conyugales, con instrumentalización del hijo. Violencia en el círculo familiar.</li>
                                      </ul>

                                  </div>
                              </div>

                              <div class="seccion">
                                  <h4 class="icon-plus">Adultos</h4>
                                  <div class="secContenido">
                                      <ul>
                                          <li>Fracaso profesional.</li>
                                          <li>Pérdida de empleo (primer año) o dificultades económicas.</li>
                                          <li>Pérdida de estatus o prestigio social.</li>
                                          <li>Ruptura conyugal, desengaño amoroso.</li>
                                          <li>Jubilación.</li>
                                          <li>Alcoholismo.</li>
                                      </ul>

                                  </div>
                              </div>

                              <div class="seccion">
                                  <h4 class="icon-plus">Adultos mayores</h4>
                                  <div class="secContenido">
                                      <ul>
                                          <li>Empeoramiento de enfermedades, aumento del dolor, fracaso, hartazgo, aumento de la dependencia. Pérdida de funciones físicas o psicológicas básicas.</li>
                                          <li>Institucionalización. Etapa de adaptación a un hogar de ancianos.</li>
                                          <li>Malos tratos.</li>
                                          <li>Cambio periódico de domicilio.</li>
                                          <li>Viudez (especialmente el primer año).</li>
                                          <li>Sentimientos de soledad e inutilidad. Inactividad.</li>
                                          <li>Pérdida de interés por la vida.</li>
                                          <li>Pérdida de la fe.</li>
                                      </ul>

                                  </div>
                              </div>

                            </div>
                        </div>

                        <div class="seccion">
                            <h4 class="icon-plus">Dimensiones suicidológicas</h4>
                            <div class="secContenido">
                                <ul>
                                    <li>Ideación suicidas: presencia, contenido, intensidad, frecuencia, duración.</li>
                                    <li>Plan suicida: grado de planeación vinculado a cómo llevarlo a cabo.</li>
                                    <li>Intento previo: presencia, método utilizado, circunstancias que rodearon el acto.</li>
                                    <li>Antecedentes en la familia y/o entorno social próximo.</li>
                                </ul>

                            </div>
                        </div>

                        </div>
                    </div>
                    <div class="seccion">
                        <h4 class="icon-plus">Instrumentos psicológicos disponibles</h4>
                        <div class="secContenido">
                          <p>Existen diferentes tipos de instrumentos psicológicos para evaluar el riesgo de suicidio.</p>

                          <div class="seccion">
                              <h4 class="icon-plus">Screening</h4>
                              <div class="secContenido">
                                <p>Indagan la presencia de ideaciones suicidas y factores protectores/de riesgo, entendiendo que
                                ello es indicador de una persona en alguna “fase” del proceso suicida (por ej. Ideación suicida,
                                  plan suicida). En general su utilidad principal radica en que son rápidos y prácticos para aplicar
                                  en grupos numerosos en contextos comunitarios o escolares (Goldston, 2000).<br/>
                                Sin embargo, también resultan útiles en contextos clínicos individuales.
                                Nock et al. (2008) y Posner (2016) sugieren que se debe evaluar mediante screening a todos los
                                pacientes y no solamente a aquellos que explícitamente manifiestan tener ideas o intento de suicidio.</p>
                                  <ul>
                                      <li><b>Inventario de Orientaciones Suicidas ISO-30</b> (King & Kowalchuk; Fernández Liporace & Casullo, 2006).</li>
                                      <li><b>Inventario de Orientaciones Suicidas ISO-19</b> (versión reducida 2019) (Galarza, Fernández Liporace, Castañeiras & Freiberg Hoffman, 2019).</li>
                                      <li><b>Escala Argentina de Suicidalidad para Adolescentes EASA-I Screening</b> (Galarza, Castañeiras & Fernández Liporace, 2019)</li>
                                      <li><b>Escala de Riesgo Suicida de Plutchik</b> (no posee adaptación argentina)</li>
                                  </ul>

                              </div>
                          </div>

                          <div class="seccion">
                              <h4 class="icon-plus">Diagnóstico</h4>
                              <div class="secContenido">
                                <p>Se focalizan en determinar si hay riesgo inminente, al evaluar la potencialidad del
                                acto suicida, es decir la intencionalidad suicida. Indagan en profundidad una serie de
                                variables suicidológicas específicas, como son planeación, antecedentes de intento de
                                suicidio de la persona y su familia, comportamientos asociados a la capacidad adquirida
                                para suicidarse (por ej.: presencia de NSSI).<br/>
                                Es importante destacar que la evaluación diagnóstica siempre debe realizarse en
                                forma individual y progresiva, a través del uso combinado de instrumentos autoadministrables
                                y heteroadminstrables, siempre, por supuesto, dentro del marco de una entrevista psicológica con los
                                profesionales de la salud (Nock et al. 2008; Posner, 2016).</p>
                                  <ul>
                                      <li><b>Escala Argentina de Suicidalidad para Adolescentes EASA-II Diagnóstico</b> (Galarza, 2021).</li>
                                      <li><b>Escala de Ideación Suicida BSI</b> (Beck & Steer, 1991) (no posee adaptación argentina).</li>
                                      <li><b>Escala de Intencionalidad Suicida SIS</b> (Beck et al., 1974) (no posee adaptación argentina).</li>
                                  </ul>

                              </div>
                          </div>

                          <div class="seccion">
                              <h4 class="icon-plus">Otros instrumentos para evaluar actitudes hacia el suicidio</h4>
                              <div class="secContenido">
                                  <ul>
                                      <li><b>Escala Multi-Actitudinal de Tendencia Suicida</b> (MAST, acrónimo en inglés; Orbach et al., 1991; adaptación Casullo, Bonaldi, & Fernández Liporace, 2006).</li>
                                      <li><b>Cuestionario de Creencias Actitudinales sobre el Comportamiento Suicida CCCS-18</b> (Ruiz-Hernández, Navarro-Ruiz, Torrente Hernández, & Rodríguez Gonzales, 2005; adaptación Desuque, Vargas, Rubilar & Lemos, 2011).</li>
                                  </ul>

                              </div>
                          </div>

                          <div class="seccion">
                              <h4 class="icon-plus">En contexto hospitalario</h4>
                              <div class="secContenido">
                                  <ul>
                                      <li><b>Planilla de Evaluación de riesgo para los profesionales de urgencia (guardia)</b> (Ministerio de Salud Argentina).</li>
                                      <li><b>Cuestionario sugerido para realizar la evaluación de riesgo por los profesionales de Salud Mental</b> (Ministerio de Salud Argentina).</li>
                                  </ul>

                              </div>
                          </div>

                        </div>
                        
                    </div>
                    <div class="seccion">
                        <h4 class="icon-plus">Guías y protocolos nacionales e internacionales</h4>
                        <div class="secContenido">
                          <ul>
                              <li
                                style={StyleLiPDFS}
                              ><a href={pdf3}>Suicidio adolescente. UNICEF, 2019.</a></li>
                              <li
                                style={StyleLiPDFS}
                              ><a href={pdf4}>Lineamientos para la atención del intento de suicidio en adolescentes. Ministerio de Desarrollo Social y Salud de la Nación, 2018.</a></li>
                              <li
                                style={StyleLiPDFS}
                              ><a href={pdf5}>Lineamientos generales para la comprensión, detección y prevención. UBA, 2016.</a></li>
                              <li
                                style={StyleLiPDFS}
                              ><a href={pdf6}>Políticas de cuidado en la escuela. Aportes para trabajar la problemática del suicidio e intentos de suicidio. Dirección General de Cultura y Educación, Pcia. BsAs., 2017.</a></li>
                              <li
                                style={StyleLiPDFS}
                              ><a href={pdf7}>Prevención del suicidio. Un instrumento para policías, bomberos y otros socorristas de primera línea. Organización Mundial de la Salud, 2009.</a></li>
                              <li
                                style={StyleLiPDFS}
                              ><a href={pdf8}>Guía para la detección y prevención de la conducta suicida dirigida a profesionales sanitarios y facilitadores sociales. Comunidad de Madrid, España, 2014.</a></li>
                              <li
                                style={StyleLiPDFS}
                              ><a href={pdf9}>Guía de autoayuda. Prevención del Suicidio. ¿Qué puedo hacer? Comunidad de Madrid, España, 2014.</a></li>
                              <li
                                style={StyleLiPDFS}
                              ><a href={pdf10}>Guía para familiares. detección y prevención de la conducta suicida en personas con una enfermedad mental. Comunidad de Madrid, España, 2014.</a></li>
                              <li
                                style={StyleLiPDFS}
                              ><a href={pdf11}>Recomendaciones sobre la detección, prevención e intervención de la conducta suicida. Servicio Andaluz de Salud, España, 2010.</a></li>
                              <li
                                style={StyleLiPDFS}
                              ><a href={pdf12}>Guía de Práctica Clínica de Prevención y Tratamiento de la Conducta Suicida. Ministerio de Sanidad y Política Social, España, 2012.</a></li>
                          </ul>
                        </div>
                    </div>
                </div>

                <div class="card formTextItem">
                        <h1>Algunas técnicas de intervención</h1>
                        
                        
                        <div class="seccion">
                            <h4 class="icon-plus"><b>Plan de seguridad</b></h4>
                            <div class="secContenido">
                                <p>
                                <ul>
                                    <li>Se trata de una técnica de intervención muy simple que se puede elaborar en forma conjunta con las persona con riesgo de suicidio.</li>
                                    <li>El objetivo es generar estrategias de afrontamiento internas y externas,  y recursos para que la persona pueda manejar la crisis y evitar hacerse daño.</li>
                                    <li>Útil para recuperar sensación de control y dominio sobre sí mismo, y potenciar el uso de recursos propios del paciente.</li>
                                    <li>Si lo hace en formato papel, cada paso debe tener el tamaño de una tarjeta para llevarlo siempre consigo. Sino, se puede almacenar en la app.</li>
                                    
                                    Fuente: 
                                    <a href="http://suicidesafetyplan.com/uploads/Safety_Planning_-_Cog___Beh_Practice.pdf">
                                        &nbsp;Stanley, B., & Brown, G. K. (2012). Safety Plan Intervention. A Brief Intervention to 
                                        Mitigate Suicide Risk. Cognitive and Behavioral Practice 19 (2012) 256-264. 
                                    </a><br />
                                    A continuación se expone en forma abreviada el Plan de Seguridad tal como aparece disponible en la sección Tengo pensamientos sobre la muerte de esta app: 

                                </ul>

                                <h3 style={{marginTop: "15px"}}>Mi plan de seguridad:</h3>
                                <div class="seccion">
                                    <h4 class="icon-plus">Señales de alerta</h4>
                                    <div class="secContenido">
                                        <p>Pensá en las circunstancias que te llevaron a tener ideas suicidas o sentir ganas de hacerte daño.</p>
                                    </div>
                                </div>

                                <div class="seccion">
                                    <h4 class="icon-plus">Actividades que puedo hacer solo para no pensar</h4>
                                    <div class="secContenido">
                                        <p>Anotá actividades que podés hacer solx y te sirven para distraerte cuando te sentís mal, para disminuir el malestar, o tranquilizarte. Puede ser alguna actividad física, salir a pasear al aire libre, escuchar música, jugar algún juego, ordenar, etc.</p>
                                    </div>
                                </div>

                                <div class="seccion">
                                    <h4 class="icon-plus">Con quiénes puedo hablar para distraerme</h4>
                                    <div class="secContenido">
                                        <p>Identificá cuáles son esas personas de tu entorno que te pueden ayudar a distraerte cuando te sentís mal.</p>
                                    </div>
                                </div>

                                <div class="seccion">
                                    <h4 class="icon-plus">Con quiénes puedo hablar de lo que me pasa</h4>
                                    <div class="secContenido">
                                        <p>Anotá las personas de confianza –profesionales, familiares, amigxs- con las que podés hablar honestamente de lo que te está pasando en el momento de crisis. Es importante que les avises que los vas a llamar para que te ayuden en esta situación.</p>
                                    </div>
                                </div>

                                <div class="seccion">
                                    <h4 class="icon-plus">Listado de números de asistencia en mi ciudad</h4>
                                    <div class="secContenido">
                                        <p>Armá el listado de los números de emergencia a los que podés llamar en caso que los pasos anteriores no hayan servido para manejar la crisis.</p>
                                    </div>
                                </div>
                                </p>
                            </div>
                        </div>
                        <div class="seccion">
                            <h4 class="icon-plus">Dispositivo de postvención en escuelas del Servicio de Salud Mental</h4>
                            <div class="secContenido">
                                <p>Se trata de un dispositivo de intervención intersectorial, ya que reúne sectores de niñez,
                                educación y salud, a nivel municipal y provincial (Gral. Pueyrredón, BsAs). Su objetivo es
                                realizar una intervención en escuelas en las que haya ocurrido un intento de suicidio o un
                                suicidio consumado, para brindar apoyo, contención y reducir la probabilidad de nuevos intentos.<br/>
                                <b>Para solicitarlo, las escuelas de gestión pública deben contactarse con los inspectores de psicologia.</b></p>

                            </div>
                        </div>
                        <div class="seccion">
                            <h4 class="icon-plus">Programa de intervención psicosocial</h4>
                            <div class="secContenido">
                                <p>Es un programa de intervención psicosocial original, versátil y estructurado,
                                diseñado tras el estudio y evaluación de 800 jóvenes de la ciudad de Mar del Plata.
                                Su finalidad es la promoción de salud en adolescentes. Los contenidos y actividades están articulados
                                en 4 módulos transversales con una organización clara y dinámica en modalidad taller, que
                                busca estimular la participación de lxs adolescentes, a través de actividades psicoeducativas,
                                grupales y tareas interencuentro.<br/>
                                <b>Contacto: Dr. Juan Cingolani y Dra. Claudia Castañeiras</b><br/>( <a href="https://www.pips-a.com/">https://www.pips-a.com/</a> )
                                </p>
                            </div>
                        </div>
                        <div class="seccion">
                            <h4 class="icon-plus">Grupo de entrenamiento en habilidades DBT para adolescentes</h4>
                            <div class="secContenido">
                                <p>Dirigido a adolescentes y sus familias. Se basa en la terapia Dialectico
                                Comportamental y brinda recursos para reducir la vulnerabilidad emocional y afrontar
                                problemas de la vida.<br/>
                                <b>Contacto: <a href="mailto:dbtmardelplata@gmail.com">dbtmardelplata@gmail.com</a> | <a href="tel:2234499401">223 449-9401</a> | <a href="tel:2235333886">223 533-3886</a></b>
                                </p>
                            </div>
                        </div>
                    </div>

            </React.Fragment>
        )
    }
}

/*

<div class="contenedor">
                    <h2>Información para Profesionales de salud y docentes</h2>
                    <div class="seccion">
                        <h3 class="icon-plus">Marco legal y normativo argentino</h3>
                        <div class="secContenido">
                            <p>
                                Los hallazgos de la evaluación basada en la evidencia (EBA) en suicidología
                                indican la importancia de comenzar siempre indagando la presencia de ideaciones
                                suicidas, su frecuencia, contenido y duración, para luego abordar los temas y áreas
                                más sensibles, como por ejemplo planeación, antecedentes de intento de suicidio de la
                                persona y su familia, todo lo relativo a dicho plan o intento, comportamientos
                                asociados a la capacidad adquirida para suicidarse (por ejemplo, presencia de autolesiones
                                 no suicidas - NSSI) (Nock, Wedig, Janis & Deliberto, 2008).
                            </p>

                            <div class="seccion">
                                <h4 class="icon-plus">Ley Nacional de prevencion del suicidio N°27.130</h4>
                                <div class="secContenido">
                                    <p>Descargar: <a href={pdf1}>Ley Nacional de prevencion del suicidio N°27.130</a></p>

                                </div>
                            </div>
                            <div class="seccion">
                                <h4 class="icon-plus">Ley Nacional de salud mental N°26.667</h4>
                                <div class="secContenido">
                                    <p>Descargar: <a href={pdf2}>Ley Nacional de salud mental N°26.667</a></p>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="seccion">
                        <h3 class="icon-plus">Delimitaciones conceptuales</h3>
                        <div class="secContenido">
                            <img src={imgDC} style={{width: "100%"}}/>
                            <ul>
                              <li><b>Suicidio:</b> acto deliberado que realiza una persona para poner fin a su vida.</li>
                              <li><b>Ideación suicida:</b> en sentido estricto, comprende la aparición de pensamientos y sentimientos cuyo contenido se relaciona con poner fin a la propia existencia.</li>
                              <li><b>Plan suicida:</b> formulación concreta y específica de un método para quitarse la vida y la posible preparación para llevarlo a cabo, de modo tal de diferenciarlo respecto del concepto ideaciones suicidas.  La presencia de un plan suicida está altamente vinculada a una mayor probabilidad de cometer un intento de suicidio.</li>
                              <li><b>Intento de suicidio:</b> alude a la tentativa deliberada de autoeliminación o autolesión intencionada sin resultado de muerte.</li>
                              <li><b>Riesgo de suicidio:</b> propensión que exhibe una persona en un momento dado para desarrollar ideaciones suicidas y/o cometer un intento de suicidio.</li>
                              <li><b>Gesto suicida:</b> acto realizado con el fin de aparentar la intención de quitarse la vida para lograr atención y comunicación con el entorno. No presenta intencionalidad suicida.</li>
                              <li><b>Pensamientos sobre autolesiones no suicidas:</b> pensamientos y sentimientos vinculados a provocarse daño físico, sin presencia de ideas sobre quitarse la propia vida.</li>
                              <li><b>NSSI Autolesiones no suicidas:</b> lesiones autoinfligidas en la superficie corporal como mecanismo regulatorio de un estado negativo emocional o cognitivo, sin intencionalidad suicida.</li>
                            </ul>
                            <p> </p>
                            <p></p>
                        </div>
                    </div>

                    <div class="seccion">
                        <h3 class="icon-plus">Que es y como evaluar el riesgo de suicidio</h3>
                        <div class="secContenido">
                          <p>Los hallazgos de la evaluación basada en la evidencia (EBA) en suicidología indican la importancia
                          de comenzar siempre indagando la presencia de ideaciones suicidas, su frecuencia, contenido y duración,
                          para luego abordar los temas y áreas más sensibles, como por ejemplo planeación, antecedentes de intento
                          de suicidio de la persona y su familia, todo lo relativo a dicho plan o intento, comportamientos
                          asociados a la capacidad adquirida para suicidarse
                          (por ejemplo, presencia de autolesiones no suicidas - NSSI) (Nock, Wedig, Janis & Deliberto, 2008).
                          Asimismo, es necesario indagar la presencia de factores protectores,  de riesgo y desencadenantes.
                          Esta evaluación debe realizarse a través de una entrevista  individual, en un espacio de confianza y calidez.
                          También se recomienda incluir otro tipo de técnicas de evaluación como cuestionarios psicológicos,
                          para lograr un abordaje multimétodo. </p>
                          <p>De forma complementaria, es necesario tener una entrevista con familiares y/o allegados para
                          conocer su percepción de la situación y el estado general de la persona en crisis, así como realizar
                          intervenciones concretas dirigidas a brindar información y orientar a la red de apoyo para el acompañamiento.</p><br/>
                          <p>Es muy importante mantener una determinada actitud cuando se entrevista a alguien con pensamientos suicidas:</p><br/>
                          <ul>
                            <li>Ser comprensivo, cariñoso, empático, validar la experiencia y generar un clima de confianza.</li>
                            <li>Nunca juzgar la conducta, no estigmatizar, no atemorizarse, ni enojarse.</li>
                            <li>No minimizar ni maximizar el riesgo hasta finalizar la evaluación y determinar cuáles son las intervenciones más adecuadas.</li>
                            <li>Recordar que preguntarle a una persona con pensamientos y comportamientos suicidas sobre el tema, no aumenta el riesgo de suicidio, siempre que mantengamos una actitud de escucha y comprensión. </li>
                          </ul><br/>
                          <p>Para profundizar esta información se recomienda revisar:</p><br/>
                          <ul>
                            <li><a href={pdf5}>Lineamientos generales para la comprensión, detección y prevención (UBA, 2016).</a></li>
                            <li><a href={pdf12}>Guía de Práctica Clínica de Prevención y Tratamiento de la Conducta Suicida (Ministerio de Sanidad y Política Social, España, 2012).</a></li>
                          </ul>
                        </div>
                    </div>

                    <div class="seccion">
                        <h3 class="icon-plus">Dimensiones a evaluar</h3>
                        <div class="secContenido">

                        <div class="seccion">
                            <h4 class="icon-plus">Factores protectores</h4>
                            <div class="secContenido">
                                <ul>
                                    <li>Buena autoestima</li>
                                    <li>Percepción de contar con una red social de apoyo.</li>
                                    <li>Buena comunicación familiar.</li>
                                    <li>Sentimiento de pertenencia.</li>
                                    <li>Buena regulación emocional.</li>
                                    <li>Sensación de autocontrol.</li>
                                    <li>Capacidad para la resolución de problemas.</li>
                                    <li>Perspectiva optimista respecto del futuro.</li>
                                    <li>Flexibilidad.</li>
                                </ul>

                            </div>
                        </div>

                        <div class="seccion">
                            <h4 class="icon-plus">Factores de riesgo</h4>
                            <div class="secContenido">
                                <ul>
                                    <li>Baja autoestima</li>
                                    <li>Sentimientos de soledad y aislamiento, de estar atrapado.</li>
                                    <li>Percepción de ser una carga para los demás.</li>
                                    <li>Dificultades en la regulación emocional.</li>
                                    <li>Impulsividad.</li>
                                    <li>Dificultades en la resolución de problemas.</li>
                                    <li>Percepción de apoyo social.</li>
                                    <li>Perspectiva pesimista respecto del futuro.</li>
                                    <li>Autolesiones no suicidas.</li>
                                    <li>Presencia de cuadro psicopatológico (en especial: depresión mayor, trastorno bipolar, esquizofrenia, trastorno límite de personalidad).</li>
                                </ul>

                            </div>
                        </div>

                        <div class="seccion">
                            <h4 class="icon-plus">Factores precipitantes</h4>
                            <div class="secContenido">
                              <p>Presencia de algún o varios eventos vitales significativos que pueden desencadenar una crisis:</p>

                              <div class="seccion">
                                  <h4 class="icon-plus">Comunes a todas las edades</h4>
                                  <div class="secContenido">
                                      <ul>
                                          <li>Accidentes o diagnóstico, empeoramiento o crisis de enfermedades graves, incapacitantes o dolorosas. Propias o ajenas.</li>
                                          <li>Desastres naturales.</li>
                                          <li>Pérdida de seres queridos (incluidos animales de compañía).</li>
                                          <li>Existencia de entorno suicida: fácil acceso a medios letales, epidemias suicidas, suicidio de familiares o personas cercanas, acceso a información y relaciones inadecuadas en medios de información, comunicación y redes sociales etc..</li>
                                          <li>Experiencias y vivencias traumáticas: agresiones y malos tratos, acosos y humillaciones, abusos sexuales, etc.</li>
                                          <li>Aumento o consumo de sustancias tóxicas.</li>
                                          <li>Estado de embriaguez o intoxicación.</li>
                                          <li>Imputaciones o condenas judiciales.</li>
                                          <li>Disputas y conflictos con familiares o personas cercanas.</li>
                                          <li>Embarazo no deseado o aborto.</li>
                                          <li>Cambios vitales bruscos no deseados.</li>
                                          <li>Efectos secundarios suicidógenos de medicaciones.</li>
                                          <li>Alta por hospitalización psiquiátrica (primera semana).</li>
                                      </ul>

                                  </div>
                              </div>

                              <div class="seccion">
                                  <h4 class="icon-plus">Adolescentes y jóvenes</h4>
                                  <div class="secContenido">
                                      <ul>
                                          <li>Fracaso escolar. Problemas disciplinarios escolares. Presión escolar. Períodos de exámenes.</li>
                                          <li>Bullying, acoso, humillaciones, malos tratos.</li>
                                          <li>Abuso sexual. Violaciones.</li>
                                          <li>Descubrimiento o no aceptación de la homosexualidad o identidad de género trans.</li>
                                          <li>Separación o pérdida de amigos y compañeros. Cambios habituales de residencia y de entorno social.</li>
                                          <li>Desengaño amoroso.</li>
                                          <li>Muerte de un ser querido.</li>
                                          <li>Entorno suicida. Presión para cometer suicidio.</li>
                                          <li>Embarazo adolescente.</li>
                                          <li>Separación de los padres o graves conflictos conyugales, con instrumentalización del hijo. Violencia en el círculo familiar.</li>
                                      </ul>

                                  </div>
                              </div>

                              <div class="seccion">
                                  <h4 class="icon-plus">Adultos</h4>
                                  <div class="secContenido">
                                      <ul>
                                          <li>Fracaso profesional.</li>
                                          <li>Pérdida de empleo (primer año) o dificultades económicas.</li>
                                          <li>Pérdida de estatus o prestigio social.</li>
                                          <li>Ruptura conyugal, desengaño amoroso.</li>
                                          <li>Jubilación.</li>
                                          <li>Alcoholismo.</li>
                                      </ul>

                                  </div>
                              </div>

                              <div class="seccion">
                                  <h4 class="icon-plus">Adultos mayores</h4>
                                  <div class="secContenido">
                                      <ul>
                                          <li>Empeoramiento de enfermedades, aumento del dolor, fracaso, hartazgo, aumento de la dependencia. Pérdida de funciones físicas o psicológicas básicas.</li>
                                          <li>Institucionalización. Etapa de adaptación a un hogar de ancianos.</li>
                                          <li>Malos tratos.</li>
                                          <li>Cambio periódico de domicilio.</li>
                                          <li>Viudez (especialmente el primer año).</li>
                                          <li>Sentimientos de soledad e inutilidad. Inactividad.</li>
                                          <li>Pérdida de interés por la vida.</li>
                                          <li>Pérdida de la fe.</li>
                                      </ul>

                                  </div>
                              </div>

                            </div>
                        </div>

                        <div class="seccion">
                            <h4 class="icon-plus">Dimensiones suicidológicas</h4>
                            <div class="secContenido">
                                <ul>
                                    <li>Ideación suicidas: presencia, contenido, intensidad, frecuencia, duración.</li>
                                    <li>Plan suicida: grado de planeación vinculado a cómo llevarlo a cabo.</li>
                                    <li>Intento previo: presencia, método utilizado, circunstancias que rodearon el acto.</li>
                                    <li>Antecedentes en la familia y/o entorno social próximo.</li>
                                </ul>

                            </div>
                        </div>

                        </div>
                    </div>

                    <div class="seccion">
                        <h3 class="icon-plus">Instrumentos psicológicos disponibles</h3>
                        <div class="secContenido">
                          <p>Existen diferentes tipos de instrumentos psicológicos para evaluar el riesgo de suicidio.</p>

                          <div class="seccion">
                              <h4 class="icon-plus">Screening</h4>
                              <div class="secContenido">
                                <p>Indagan la presencia de ideaciones suicidas y factores protectores/de riesgo, entendiendo que
                                ello es indicador de una persona en alguna “fase” del proceso suicida (por ej. Ideación suicida,
                                  plan suicida). En general su utilidad principal radica en que son rápidos y prácticos para aplicar
                                  en grupos numerosos en contextos comunitarios o escolares (Goldston, 2000).</p>
                                <p>Sin embargo, también resultan útiles en contextos clínicos individuales.
                                Nock et al. (2008) y Posner (2016) sugieren que se debe evaluar mediante screening a todos los
                                pacientes y no solamente a aquellos que explícitamente manifiestan tener ideas o intento de suicidio.</p>
                                  <ul>
                                      <li>Inventario de Orientaciones Suicidas ISO-30 (King & Kowalchuk; Fernández Liporace & Casullo, 2006).</li>
                                      <li>Inventario de Orientaciones Suicidas ISO-19 (versión reducida 2019) (Galarza, Fernández Liporace, Castañeiras & Freiberg Hoffman, 2019).</li>
                                      <li>Escala Argentina de Suicidalidad para Adolescentes EASA-I Screening (Galarza, 2019)</li>
                                      <li>Escala de Riesgo Suicida de Plutchik (no posee adaptación argentina)</li>
                                  </ul>

                              </div>
                          </div>

                          <div class="seccion">
                              <h4 class="icon-plus">Diagnóstico</h4>
                              <div class="secContenido">
                                <p>Se focalizan en determinar si hay riesgo inminente, al evaluar la potencialidad del
                                acto suicida, es decir la intencionalidad suicida. Indagan en profundidad una serie de
                                variables suicidológicas específicas, como son planeación, antecedentes de intento de
                                suicidio de la persona y su familia, comportamientos asociados a la capacidad adquirida
                                para suicidarse (e.g., presencia de NSSI).</p>
                                <p>Es importante destacar que la evaluación diagnóstica siempre debe realizarse en
                                forma individual y progresiva, a través del uso combinado de instrumentos autoadministrables
                                y heteroadminstrables, siempre, por supuesto, dentro del marco de la entrevista psicológica
                                (Nock et al. 2008; Posner, 2016).</p>
                                  <ul>
                                      <li>Escala Argentina de Suicidalidad para Adolescentes EASA-II Diagnóstico.</li>
                                      <li>Escala de Ideación Suicida BSI (Beck & Steer, 1991) (no posee adaptación argentina).</li>
                                      <li>Escala de Intencionalidad Suicida SIS (Beck et al., 1974) (no posee adaptación argentina).</li>
                                      <li>Escala BHS de Beck (Beck et al., 1974; adaptación argentina Mikulic, 1998; Mikulic, Cassullo, Crespi, & Marconi, 2009.</li>
                                  </ul>

                              </div>
                          </div>

                          <div class="seccion">
                              <h4 class="icon-plus">Otros instrumentos para evaluar actitudes hacia el suicidio</h4>
                              <div class="secContenido">
                                  <ul>
                                      <li>Escala Multi-Actitudinal de Tendencia Suicida (MAST, acrónimo en inglés; Orbach et al., 1991; adaptación Casullo, Bonaldi, & Fernández Liporace, 2006).</li>
                                      <li>Cuestionario de Creencias Actitudinales sobre el Comportamiento Suicida CCCS-18 (Ruiz-Hernández, Navarro-Ruiz, Torrente Hernández, & Rodríguez Gonzales, 2005; adaptación Desuque, Vargas, Rubilar & Lemos, 2011).</li>
                                  </ul>

                              </div>
                          </div>

                          <div class="seccion">
                              <h4 class="icon-plus">En contexto hospitalario</h4>
                              <div class="secContenido">
                                  <ul>
                                      <li>Planilla de Evaluación de riesgo para los profesionales de urgencia (guardia) (Ministerio de Salud Argentina).</li>
                                      <li>Cuestionario sugerido para realizar la evaluación de riesgo por los profesionales de Salud Mental (Ministerio de Salud Argentina).</li>
                                  </ul>

                              </div>
                          </div>

                        </div>
                    </div>

                    <div class="seccion">
                        <h3 class="icon-plus">Guías y protocolos nacionales e internacionales</h3>
                        <div class="secContenido">
                          <ul>
                              <li><a href={pdf3}>Suicidio adolescente. UNICEF, 2019.</a></li>
                              <li><a href={pdf4}>Lineamientos para la atención del intento de suicidio en adolescentes. Ministerio de Desarrollo Social y Salud de la Nación, 2018.</a></li>
                              <li><a href={pdf5}>Lineamientos generales para la comprensión, detección y prevención. UBA, 2016.</a></li>
                              <li><a href={pdf6}>Políticas de cuidado en la escuela. Aportes para trabajar la problemática del suicidio e intentos de suicidio. Dirección General de Cultura y Educación, Pcia. BsAs., 2017.</a></li>
                              <li><a href={pdf7}>Prevención del suicidio. Un instrumento para policías, bomberos y otros socorristas de primera línea. Organización Mundial de la Salud, 2009.</a></li>
                              <li><a href={pdf8}>Guía para la detección y prevención de la conducta suicida dirigida a profesionales sanitarios y facilitadores sociales. Comunidad de Madrid, España, 2014.</a></li>
                              <li><a href={pdf9}>Guía de autoayuda. Prevención del Suicidio. ¿Qué puedo hacer? Comunidad de Madrid, España, 2014.</a></li>
                              <li><a href={pdf10}>Guía para familiares. detección y prevención de la conducta suicida en personas con una enfermedad mental. Comunidad de Madrid, España, 2014.</a></li>
                              <li><a href={pdf11}>Recomendaciones sobre la detección, prevención e intervención de la conducta suicida. Servicio Andaluz de Salud, España, 2010.</a></li>
                              <li><a href={pdf12}>Guía de Práctica Clínica de Prevención y Tratamiento de la Conducta Suicida. Ministerio de Sanidad y Política Social, España, 2012.</a></li>
                          </ul>
                        </div>
                    </div>

                    <div class="seccion">
                        <h3 class="icon-plus">Algunas técnicas de intervención</h3>
                        <div class="secContenido">
                            <p></p>


                            <div class="seccion">
                                <h4 class="icon-plus"><b>Plan de seguridad</b></h4>
                                <div class="secContenido">
                                    <p>El objetivo del Plan de Seguridad es ayudar a la persona a superar la crisis. Para poder hacerlo,
                                    se identifican personas, lugares, ideas o acciones que facilitan la superación de la ideación suicida
                                    propia o ajena.
                                    </p><p style={{marginTop: "5px"}}>
                                    Aunque en general está dirigido a las personas con riesgo suicida, también es importante que las
                                    personas como vos que estén ayudando a alguien en riesgo, elaboren su propio Plan de Seguridad
                                    para identificar estrategias para manejar la situación y contactos a los que podés acudir.
                                    </p>

                                    <div class="seccion">
                                        <h4 class="icon-plus">Señales de alerta</h4>
                                        <div class="secContenido">
                                          <p>Pensá en las circunstancias que te llevaron a tener ideas suicidas o sentir ganas de hacerte daño.</p>
                                        </div>
                                    </div>

                                    <div class="seccion">
                                        <h4 class="icon-plus">Actividades que puedo hacer solo para no pensar</h4>
                                        <div class="secContenido">
                                          <p>Anotá actividades que podés hacer solx y te sirven para distraerte cuando te sentís mal, para disminuir el malestar, o tranquilizarte. Puede ser alguna actividad física, salir a pasear al aire libre, escuchar música, jugar algún juego, ordenar, etc.</p>
                                        </div>
                                    </div>

                                    <div class="seccion">
                                        <h4 class="icon-plus">Con quiénes puedo hablar para distraerme</h4>
                                        <div class="secContenido">
                                          <p>Identificá cuáles son esas personas de tu entorno que te pueden ayudar a distraerte cuando te sentís mal.</p>
                                        </div>
                                    </div>

                                    <div class="seccion">
                                        <h4 class="icon-plus">Con quiénes puedo hablar de lo que me pasa</h4>
                                        <div class="secContenido">
                                          <p>Anotá las personas de confianza –profesionales, familiares, amigxs- con las que podés hablar honestamente de lo que te está pasando en el momento de crisis. Es importante que les avises que los vas a llamar para que te ayuden en esta situación.</p>
                                        </div>
                                    </div>

                                    <div class="seccion">
                                        <h4 class="icon-plus">Listado de números de asistencia en mi ciudad</h4>
                                        <div class="secContenido">
                                          <p>Armá el listado de los números de emergencia a los que podés llamar en caso que los pasos anteriores no hayan servido para manejar la crisis.</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="seccion">
                                <h4 class="icon-plus">Dispositivo de postvención en escuelas del Servicio de Salud Mental</h4>
                                <div class="secContenido">
                                    <p>Se trata de un dispositivo de intervención intersectorial, ya que reúne sectores de niñez,
                                    educación y salud, a nivel municipal y provincial (Gral. Pueyrredón, BsAs). Su objetivo es
                                    realizar una intervención en escuelas en las que haya ocurrido un intento de suicidio o un
                                    suicidio consumado, para brindar apoyo, contención y reducir la probabilidad de nuevos intentos.
                                    Contacto: Informar a inspectoras de psicología comunitaria y pedagogía del distrito de General Pueyrredón</p>

                                </div>
                            </div>
                            <div class="seccion">
                                <h4 class="icon-plus">Programa de intervención psicosocial</h4>
                                <div class="secContenido">
                                    <p>Es un programa de intervención psicosocial original, versátil y estructurado,
                                    diseñado tras el estudio y evaluación de 800 jóvenes de la ciudad de Mar del Plata.
                                    Su finalidad es la promoción de salud en adolescentes. Los contenidos y actividades están articulados
                                    en 4 módulos transversales con una organización clara y dinámica en modalidad taller, que
                                    busca estimular la participación de lxs adolescentes, a través de actividades psicoeducativas,
                                    grupales y tareas interencuentro.</p>
                                    <p style={{fontSize: "16px", marginTop: "10px"}}>Contacto: Dr. Juan Cingolani y Dra. Claudia Castañeiras<br/>( <a href="https://www.pips-a.com/">https://www.pips-a.com/</a> )</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

*/